import './style.scss';


import './scripts/general';
import './scripts/header';
import './scripts/navigation';

import './scripts/advantagesSection';
import './scripts/testimonials_slider';
import './scripts/reveal_slider';
import './scripts/toggle_results';
import './scripts/history_slider';
import './scripts/content_text_slider';
import './scripts/homepage';
// import './scripts/homepage-hero-video';
import './scripts/rotation_videos';
import './scripts/page_treatment';
import './scripts/clinics';
import './scripts/patients-page';
import './scripts/formInputs';
import './scripts/smileValidate';
import './scripts/representatives_section';
import './scripts/courses-filters';
